import { Button, Grid, IconButton, TextField, Typography } from "@mui/material"
import { useState } from "react";
import { v4 as UUID } from "uuid";
import { author } from "../../../types/types";
import { FileUploadCustom } from "./FileUploadCustom";
import { CustomDialog } from "../dialogs/CustomDialog";
import Swal from "sweetalert2";
import { KeywordsCustom } from "./KeywordsCustom";



export const ParticipantWorkCustom = ({
    status = 'entregado',
    ownerId = '',
    parentCallback,
    variant = 'standard',

    // Campos que debe/puede pedir el 'work' al usuario
    keywords = false, // 3 palabras clave
    workFile = false, // subir archivo a 
}) => {


    const DEFAULT_WORK = {
        title: '',
        authors: [],

        id: UUID(),         // identificador unico del trabajo
        ownerId,            // registroReferencia del participante
        status,             // 'entregado', 'devuelto', 'aceptado'
        statusComments: '',
        keywords: [],
        url: '',            // url donde se sube el archivo de resumen
        method: '',         // 'poster', 'e-poster', 'ponencia', 'video'
        mediaFilesURL: '',  // URL donde el participante subirá los archivos a presentar (video, PDF, audio)
    }


    const [work, setWork] = useState(DEFAULT_WORK);

    const [uploadingFile, setUploadingFile] = useState(false);


    //* Cada que se carga el documento
    const handleDocumentUploaded = ({ exito, mensaje, data }) => {
        console.log({ exito, mensaje, data });

        if (exito === 0) {
            console.log('Error', mensaje);
            Swal.fire({
                title: '¡Error!',
                text: 'Por favor intenta mas tarde / Please, try again later.',
                icon: 'error',
                footer: `Tip: ${ mensaje || 'Check console.'}`
            })
            return;
        }

        setWork({ ...work, url: `https://eventos.cibnor.mx/registro/apiServiciosSIARF${ data }` });
        parentCallback({ ...work, url: `https://eventos.cibnor.mx/registro/apiServiciosSIARF${ data }` });
    }

    //* Cada que se actualiza una palabra clave
    const handleKeywordsUpdated = (keywordsArray) => {
        setWork({ ...work, keywords: keywordsArray});
        parentCallback({ ...work, keywords: keywordsArray});
    }

    //* Al presionar el boton para agregar un autor
    const handleAddAuthor = () => {
        
        const authorToAdd = JSON.parse(JSON.stringify(author));
        authorToAdd.id = UUID();
        const authorsTmp = work.authors;
        authorsTmp.push(authorToAdd);
        setWork({ ...work, authors: authorsTmp });
    }

    //* Al presionar el boton para eliminar un autor
    const handleDeleteAuthor = (id) => {
        // console.log({id}, work.authors);
        const authorsUpdated = work.authors.filter(a => a.id !== id);

        setWork({ ...work, authors: authorsUpdated });
        parentCallback({ ...work, authors: authorsUpdated });
    }

    //* Cada vez que se actualiza un campo en algun autor
    const onTriggerAuthor = ({ target }, authorId) => {
        const { name, value } = target; 

        // Obtenemos el index del autor a partir de su UID
        const authorIndex = work.authors.findIndex(a => a.id === authorId);
        // Actualizamos el autor en el 'authorIndex', en su campo 'name'
        work.authors[authorIndex][name] = value;

        parentCallback(work);
    }


    //* Cada vez que se actualiza un campo en el modulo
    const onTrigger = ({ target }) => {
        const { name, value } = target;
        setWork({ ...work, [name]: value });
        parentCallback({ ...work, [name]: value });
    };


    return (
        <>
            <CustomDialog title='Cargando archivo...' show={ uploadingFile } />

            <Grid container spacing={ 2 }>

                {/* <Grid item xs={ 12 }>
                    <Button
                        variant='outlined'
                        color='primary'
                        onClick={ () => {
                            Object.keys(work).forEach(
                                k => console.log(`${ k }:`, work[k])
                            );
                        }}
                    >
                        Test
                    </Button>
                </Grid> */}


                <Grid item xs={ 12 }>
                    <TextField  
                        fullWidth
                        helperText='Título del trabajo / Work title'
                        id='title'
                        label='Título / Title'
                        name='title'
                        onChange={ onTrigger }
                        size="small"
                        variant={ variant }
                    />
                </Grid>
                <Grid item xs={ 12 } display={ workFile ? 'flex' : 'none' }>
                    <FileUploadCustom 
                        helperText='Agregar resumen, archivo en formato DOCX / Add resume, in DOCX format'
                        parentCallback={ handleDocumentUploaded }
                        parentWaitingCallback={ (val) => setUploadingFile(val) }
                        saveFileAs= { `${ ownerId }_${ work.id }` }
                        validTypes ={ ['docx'] }
                        variant='standard'
                    />
                </Grid>
                <Grid item xs={ 12 } display={ keywords ? 'flex' : 'none' }>
                    <KeywordsCustom 
                        label='Palabras clave / Keywords'
                        maxItems={ 3 }
                        parentCallback={ handleKeywordsUpdated }
                        variant='standard'
                    />
                </Grid>

                <Grid item xs={ 12 }>
                    <Button
                        variant='outlined'
                        color='primary'
                        onClick={ () => handleAddAuthor() }
                    >
                        Agregar autor / Add author
                    </Button>
                </Grid>
                <Grid item xs={ 12 }>
                {
                    work.authors.map(({ id }, indexAuthor) => 
                        <Grid container key={ id } spacing={ 1 } pb={ 2 }>
                            <Grid item xs={ 12 }>
                                <TextField  
                                    fullWidth
                                    id='lastnames'
                                    label='Apellidos / Lastname'
                                    name='lastnames'
                                    onChange={ e => onTriggerAuthor(e, id) }
                                    size="small"
                                    variant={ variant }
                                />
                            </Grid>
                            <Grid item xs={ 12 }>
                                <TextField  
                                    fullWidth
                                    id='names'
                                    label='Nombres / Name'
                                    name='names'
                                    onChange={ e => onTriggerAuthor(e, id) }
                                    size="small"
                                    variant={ variant }
                                />
                            </Grid>
                            <Grid item xs={ 12 }>
                                <TextField  
                                    fullWidth
                                    id='institution'
                                    label='Institución / Institution'
                                    name='institution'
                                    onChange={ e => onTriggerAuthor(e, id) }
                                    size="small"
                                    variant={ variant }
                                />
                            </Grid>
                            <Grid item xs={ 12 }>
                                <TextField  
                                    fullWidth
                                    id='email'
                                    label='Correo eletrónico / Email'
                                    name='email'
                                    onChange={ e => onTriggerAuthor(e, id) }
                                    size="small"
                                    variant={ variant }
                                />
                            </Grid>
                            <Grid item xs={ 12 } display='flex' justifyContent='space-between' alignItems='center'>

                                <Typography fontWeight={ 900 } color='primary' fontStyle='italic'>
                                    {/* { console.log(indexAuthor) } */}
                                    { indexAuthor === 0 ? '1er. autor / 1st. author' : ''}
                                </Typography>

                                <Button 
                                    color='warning'
                                    variant='outlined' 
                                    onClick={ () => handleDeleteAuthor(id) }
                                >
                                    Eliminar autor / Delete author
                                </Button>
                            </Grid>
                        </Grid>
                    )
                }
                </Grid>
            </Grid>
        </>
    )
}
